const announcementsIT = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} annunci non letti",
            "empty": "Nessun annuncio",
            "newBadge": "Nuovo",
            "dismissAll": "Ignora tutto",
        },
        "modal": {
            "defaultTitle": "Annuncio",
        },
        "table": {
            "title": "Annunci",
            "column": {
                "title": "Titolo",
                "datePosted": "Data di pubblicazione",
                "dismissed": "Ignorato",
                "status": "Stato",
                "action": "Azione",
            },
            "status": {
                "read": "Letto",
                "unread": "Non letto",
            },
            "csv": {
                "statusRead": "Letto",
                "statusUnread": "Non letto",
                "dismissedYes": "Ignorato",
                "dismissedNo": "Non ignorato",
            },
            "action": {
                "view": "Vedi",
            },
            "button": {
                "exportCsv": "Esporta CSV",
            },
        },
    },
};

export default announcementsIT;
